import React from 'react';

import { Typography } from '@mui/material';

import { EmptyStateWrapper } from './styled-components';

interface EmptyStateProps {
  icon?: React.ReactNode;
  message: string;
}

// Branded, muted empty placeholder: an optional decorative icon above a short
// message. Compact enough to sit inside a board column.
export const EmptyState: React.FC<EmptyStateProps> = ({ icon, message }) => (
  <EmptyStateWrapper>
    {icon}

    <Typography color="text.secondary" variant="body2">
      {message}
    </Typography>
  </EmptyStateWrapper>
);
